import {
  PROOFREADER_ROLE_EDITOR_SUBMIT_REQUEST,
  SAVE_SLATE_DATA_FAILURE,
  SAVE_SLATE_DATA_REQUEST,
  SAVE_SLATE_DATA_SUCCESS,
  UPDATE_LAST_SAVED_TIME,
  UPDATE_SLATE_NOT_COMPLETED_NODES,
  UPDATE_SLATE_SELECTED_NODE,
  UPDATE_SLATE_VENDOR_NOTES,
  VENDOR_NAME_LIST_REQUEST,
} from '../../../../constants/ActionNameConstants';

export const saveSlateDataRequest = (data) => ({
  type: SAVE_SLATE_DATA_REQUEST,
  payload: data,
});

export const saveSlateDataSuccess = (response) => ({
  type: SAVE_SLATE_DATA_SUCCESS,
  payload: response,
});

export const ProofreaderRoleEditorSubmitRequest = (payload) => {
  return {
    type: PROOFREADER_ROLE_EDITOR_SUBMIT_REQUEST,
    payload,
  };
};
export const vendorNameListRequest = (payload) => {
  return {
    type: VENDOR_NAME_LIST_REQUEST,
    payload,
  };
};

export const saveSlateDataFailure = (error) => ({
  type: SAVE_SLATE_DATA_FAILURE,
  payload: error,
});

export const updateLastSavedTime = (data) => ({
  type: UPDATE_LAST_SAVED_TIME,
  payload: data,
});

export const updateSlateSelectedNode = (data) => ({
  type: UPDATE_SLATE_SELECTED_NODE,
  payload: data,
});

export const updateSlateVendorNotes = (data) => ({
  type: UPDATE_SLATE_VENDOR_NOTES,
  payload: data,
});
export const updateSlateNotCompletedNodes = (data) => ({
  type: UPDATE_SLATE_NOT_COMPLETED_NODES,
  payload: data,
});
